import { Routes } from '@angular/router'

import { AuthGuard } from '../auth/auth-guard.service'

import { ReleaseComponent } from './release/release.component'
import { ReleasesComponent } from './releases.component'

export const ReleaseRoutes: Routes = [
  {
    path: '',
    component: ReleasesComponent,
    canActivate: [AuthGuard],
    children: [
      { path: ':version', component: ReleaseComponent },
      { path: '', redirectTo: 'latest', pathMatch: 'full' },
    ],
  },
]
